import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { SurveyData } from "./surveysApi";

/**
 * Public API - for endpoints that don't require authentication
 * This API does NOT add auth headers or instanceId query params
 */
export const publicApi = createApi({
  reducerPath: "publicApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/v1",
  }),
  endpoints: (builder) => ({
    // ============================================
    // Public Survey Endpoints (no auth required)
    // ============================================

    getPublicSurvey: builder.query<
      {
        survey_id: string;
        title: string;
        description?: string;
        survey_data: SurveyData;
        survey_token: string;
        customer_name?: string;
      },
      { instanceId: string; token: string }
    >({
      query: ({ instanceId, token }) => `/surveys/public/${instanceId}/${token}`,
    }),

    submitPublicSurveyResponse: builder.mutation<
      { id: string; message: string },
      { instanceId: string; token: string; response_data: Record<string, unknown> }
    >({
      query: ({ instanceId, token, response_data }) => ({
        url: `/surveys/public/${instanceId}/${token}/submit`,
        method: "POST",
        body: { response_data },
      }),
    }),
  }),
});

export const { useGetPublicSurveyQuery, useSubmitPublicSurveyResponseMutation } = publicApi;
